import * as TYPES from './types';
export default {
    [TYPES.SET_RESULT](payload) {
        this.result = payload || null;
    },
    [TYPES.SET_WAITING](payload) {
        this.waiting = payload;
    },
    [TYPES.SET_PAGE_INDEX](payload) {
        this.pageIndex = payload;
    },
    // addLog( payload) {
    //     this.logs.push(payload);
    // }
};
